export const clubThemes = {
  ADE: {
    primary: "#002B5C",
    secondary: "#C8102E",
    logo: "/logos/AdelaideCrows.webp",
  },
  BRI: {
    primary: "#7C003E",
    secondary: "#FDBE10",
    logo: "/logos/BrisbaneLions.webp",
  },
  CAR: {
    primary: "#0B1F41",
    secondary: "#FFFFFF",
    logo: "/logos/Carlton.webp",
  },
  COL: {
    primary: "#000000",
    secondary: "#FFFFFF",
    logo: "/logos/Collingwood.webp",
  },
  ESS: {
    primary: "#000000",
    secondary: "#D50032",
    logo: "/logos/Essendon.webp",
  },
  FRE: {
    primary: "#2B004F",
    secondary: "#FFFFFF",
    logo: "/logos/Fremantle.webp",
  },
  GCS: {
    primary: "#B90D2B",
    secondary: "#FDB913",
    logo: "/logos/GCSuns.webp",
  },
  GEE: {
    primary: "#0B1F41",
    secondary: "#FFFFFF",
    logo: "/logos/Geelong.webp",
  },
  GWS: {
    primary: "#F15A22",
    secondary: "#FFFFFF",
    logo: "/logos/GWS.webp",
  },
  HAW: {
    primary: "#4D2004",
    secondary: "#F2A900",
    logo: "/logos/Hawthorn.webp",
  },
  MEL: {
    primary: "#0B1F41",
    secondary: "#C8102E",
    logo: "/logos/Melbourne.webp",
  },
  NM: {
    primary: "#002B5C",
    secondary: "#FFFFFF",
    logo: "/logos/North_Melbourne.webp",
  },
  PA: {
    primary: "#00B5E2",
    secondary: "#000000",
    logo: "/logos/PortAdelaide.webp",
  },
  RIC: {
    primary: "#000000",
    secondary: "#F2A900",
    logo: "/logos/Richmond.webp",
  },
  STK: {
    primary: "#ED1B2F",
    secondary: "#000000",
    logo: "/logos/StKildaFC.webp",
  },
  SYD: {
    primary: "#E41E2B",
    secondary: "#FFFFFF",
    logo: "/logos/SydneySwans.webp",
  },
  TAS: {
    primary: "#006241",
    secondary: "#FFFFFF",
    logo: "/logos/TasmaniaDevils.webp",
  },
  WCE: {
    primary: "#002B5C",
    secondary: "#FDBE10",
    logo: "/logos/West_Coast.webp",
  },
  WB: {
    primary: "#1D428A",
    secondary: "#C8102E",
    logo: "/logos/Western_Bulldogs.webp",
  },
};

export const fallbackTheme = {
  primary: "#b00020",
  secondary: "#111111",
  logo: null,
};
